import React, { useState, useEffect } from 'react'
import { IconButton, Tooltip, withStyles } from '@material-ui/core'
import { Help } from '@material-ui/icons'
import classNames from 'classnames'

const CustomTooltip = withStyles(theme => ({
  icon: {
    fontSize: '1.5rem',
    verticalAlign: 'baseline',
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
  color: { color: '#014c94' },
}))(({ classes, color, children, iconStyle }) => {
  const [open, setOpen] = useState(false)
  // Detect touch screen device
  const [isTouchDevice, setIsTouchDevice] = useState(false)

  useEffect(() => {
    setIsTouchDevice('ontouchstart' in window || navigator.maxTouchPoints > 0)
  }, [])

  const handleTooltipToggle = () => {
    // Toggle tooltip only for touch devices
    if (isTouchDevice) {
      setOpen(!open)
    }
  }

  const handleTooltipClose = () => {
    setOpen(false)
  }

  return (
    <Tooltip
      title={children}
      open={open}
      onClose={handleTooltipClose}
      onOpen={handleTooltipToggle}
      disableFocusListener={isTouchDevice}
      disableHoverListener={isTouchDevice}
      disableTouchListener={!isTouchDevice}
    >
      <IconButton
        disableRipple
        style={{ padding: 0, ...(iconStyle || {}) }}
        className={classNames(classes.icon, classes.color)}
        onClick={handleTooltipToggle}
        onMouseEnter={() => !isTouchDevice && setOpen(true)}
        onMouseLeave={() => !isTouchDevice && setOpen(false)}
      >
        <Help style={color ? { color } : null} className={classes.icon} />
      </IconButton>
    </Tooltip>
  )
})

export default CustomTooltip
